export default class LazyLoader {
	static async authPage() {
		return import(/* webpackChunkName: "AuthPage" */ 'auth/initAuthPage');
	}

	static async rankedSeasonStats() {
		return await import(/* webpackChunkName: "RankedSeasonStats" */ "../react/stats/RankedSeasonStats.jsx");
	}

	static async dailyMatches() {
		return await import(/* webpackChunkName: "DailyMatches" */ "../react/stats/DailyMatches.jsx");
	}

	static async matchMap() {
		return await import(/* webpackChunkName: "MatchMap" */ "../react/stats/MatchMap.jsx");
	}

	static async userGraphs() {
		return await import(/* webpackChunkName: "UserGraphs" */ "../pages/admin/graphs/UserGraphs.jsx");
	}

	static async subscriptionGraphs() {
		return await import(/* webpackChunkName: "SubscriptionGraphs" */ "../pages/admin/graphs/SubscriptionGraphs.jsx");
	}

	static async loginMethods() {
		const result = await import(/* webpackChunkName: "LoginMethods" */ "../pages/admin/LoginMethods.jsx");
		return result.default;
	}

	static async modChats() {
		return await import(/* webpackChunkName: "ModChats" */ "../pages/admin/ModChats.jsx");
	}

	static async modUserBugs() {
		return await import(/* webpackChunkName: "ModUserBugs" */ "../pages/admin/ModUserBugs.jsx");
	}

	static async externalKeyStatus() {
		const result = await import(/* webpackChunkName: "ExternalKeyStatus" */ "../pages/admin/ExternalKeyStatus.jsx");
		return result.default;
	}

	static async socketMonitor() {
		const socketMonitor = await import (/* webpackChunkName: "SocketMonitor" */ "../react/admin/SocketMonitor.jsx");
		return socketMonitor.default;
	}
}
